// Shared default actions to avoid duplication across config files
export const defaultCancelAction = {
  useDefaultStyle: 'cancel' as const,
  onClick: 'cancel'
};

export const defaultConfirmAction = {
  useDefaultStyle: 'confirm' as const,
  type: 'submit' as const,
  disabled: (formValue: any, formValid: boolean) => !formValid,
  onClick: 'save'
};
